import { render, staticRenderFns } from "./ReportProfitLoss.vue?vue&type=template&id=3966a884"
import script from "./ReportProfitLoss.vue?vue&type=script&lang=js"
export * from "./ReportProfitLoss.vue?vue&type=script&lang=js"
import style0 from "./ReportProfitLoss.vue?vue&type=style&index=0&id=3966a884&prod&lang=scss"
import style1 from "./ReportProfitLoss.vue?vue&type=style&index=1&id=3966a884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports